// extracted by mini-css-extract-plugin
export var audioPlayer = "_qc-0";